(() => {
  /* ============================
     🔧 CONFIGURAZIONE API SHEETS
     ============================ */

  const API_URL = "https://script.google.com/macros/s/AKfycbz2ynG2arq232y1siFjHlHxcWcWOFVZy0Dsmjmm4fLhaLZM7ttotDH8rll5bZgV3sq_/exec"; 
  const API_KEY = "ezeta_warehouse_2025_super_secret_9938FJKSLA02";


  /* ============================
     🔄 LETTURA STOCK (GET)
     ============================ */

  async function loadStock() {
    try {
      const res = await fetch(`${API_URL}?action=getStock&key=${API_KEY}`);
      const data = await res.json();
      return data.stock || {};
    } catch (err) {
      console.error("Errore GET:", err);
      alert("Errore nel recuperare lo stock.");
      return {};
    }
  }


  /* ============================
     ✏️ AGGIORNAMENTO STOCK (POST)
     ============================ */

  async function applyDeltas(deltas) {
    try {
      const res = await fetch(`${API_URL}?action=updateStock&key=${API_KEY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deltas })
      });
      const data = await res.json();
      if (!data.success) {
        console.error("Errore aggiornamento stock:", data);
        alert("Errore nell'aggiornare lo stock.");
      }
      return data;
    } catch (err) {
      console.error("Errore POST:", err);
      alert("Errore nel salvare lo stock.");
      return { success: false };
    }
  }


  /* ============================
     📦 LISTA COMPLETA PATCH
     (Codice + Nome + Immagine)
     ============================ */

  const patchList = [

    /* --- EZETA --- */
    {code:"EZ-001", name:"Ezeta oro TPU", img:"https://via.placeholder.com/300?text=EZ-001"},
    {code:"EZ-002", name:"Ezeta bianco silicone", img:"https://via.placeholder.com/300?text=EZ-002"},
    {code:"EZ-003", name:"Ezeta nero silicone", img:"https://via.placeholder.com/300?text=EZ-003"},
    {code:"EZ-004", name:"Ezeta arancione silicone", img:"https://via.placeholder.com/300?text=EZ-004"},
    {code:"EZ-005", name:"Ezeta rosso silicone", img:"https://via.placeholder.com/300?text=EZ-005"},
    {code:"EZ-006", name:"Ezeta viola silicone", img:"https://via.placeholder.com/300?text=EZ-006"},
    {code:"EZ-007", name:"Ezeta nero lucido silicone", img:"https://via.placeholder.com/300?text=EZ-007"},
    {code:"EZ-008", name:"Ezeta oro silicone Turchia", img:"https://via.placeholder.com/300?text=EZ-008"},

    /* --- LOGHI --- */
    {code:"LG-001", name:"Logo Vis Aurelia oro TPU", img:"https://via.placeholder.com/300?text=LG-001"},
    {code:"LG-002", name:"Logo Boreale b/v silicone/tessuto", img:"https://via.placeholder.com/300?text=LG-002"},
    {code:"LG-003", name:"Logo Boreale oro silicone/tessuto", img:"https://via.placeholder.com/300?text=LG-003"},
    {code:"LG-004", name:"Logo Boreale o/n silicone", img:"https://via.placeholder.com/300?text=LG-004"},
    {code:"LG-005", name:"Logo Ostiamare b/v silicone", img:"https://via.placeholder.com/300?text=LG-005"},
    {code:"LG-006", name:"Logo Ostiamare b/r silicone", img:"https://via.placeholder.com/300?text=LG-006"},
    {code:"LG-007", name:"Logo Ostiamare g/n silicone", img:"https://via.placeholder.com/300?text=LG-007"},
    {code:"LG-008", name:"Logo Romulea silicone", img:"https://via.placeholder.com/300?text=LG-008"},
    {code:"LG-009", name:"Logo Latina modì silicone", img:"https://via.placeholder.com/300?text=LG-009"},
    {code:"LG-010", name:"Logo Latina modì TPU", img:"https://via.placeholder.com/300?text=LG-010"},
    {code:"LG-011", name:"Logo Latina modì o/r TPU", img:"https://via.placeholder.com/300?text=LG-011"},
    {code:"LG-012", name:"Logo Sorrento TPU", img:"https://via.placeholder.com/300?text=LG-012"},
    {code:"LG-013", name:"Logo Sorrento silicone", img:"https://via.placeholder.com/300?text=LG-013"},
    {code:"LG-014", name:"Logo Sorrento 80s", img:"https://via.placeholder.com/300?text=LG-014"},
    {code:"LG-015", name:"Logo Albaroma silicone", img:"https://via.placeholder.com/300?text=LG-015"},

    /* --- AUTHENTIC --- */
    {code:"AU-001", name:"Authentic", img:"https://via.placeholder.com/300?text=AU-001"},
    {code:"AU-002", name:"Authentic Sibò", img:"https://via.placeholder.com/300?text=AU-002"},

    /* --- COLLO --- */
    {code:"CO-001", name:"Vis Aurelia collo oro", img:"https://via.placeholder.com/300?text=CO-001"},
    {code:"CO-002", name:"Boreale collo bianco", img:"https://via.placeholder.com/300?text=CO-002"},
    {code:"CO-003", name:"Boreale collo oro", img:"https://via.placeholder.com/300?text=CO-003"},
    {code:"CO-004", name:"Boreale collo viola", img:"https://via.placeholder.com/300?text=CO-004"},
    {code:"CO-005", name:"Boreale collo nero", img:"https://via.placeholder.com/300?text=CO-005"},
    {code:"CO-006", name:"Lidensi collo bianco", img:"https://via.placeholder.com/300?text=CO-006"},
    {code:"CO-007", name:"Lidensi collo viola", img:"https://via.placeholder.com/300?text=CO-007"},
    {code:"CO-008", name:"Lidensi collo nero", img:"https://via.placeholder.com/300?text=CO-008"},
    {code:"CO-009", name:"Romulea collo arancione", img:"https://via.placeholder.com/300?text=CO-009"},
    {code:"CO-010", name:"Romulea collo rosso", img:"https://via.placeholder.com/300?text=CO-010"},
    {code:"CO-011", name:"Littoria collo nero lucido silicone", img:"https://via.placeholder.com/300?text=CO-011"},
    {code:"CO-012", name:"Leoni alati bianco silicone", img:"https://via.placeholder.com/300?text=CO-012"},
    {code:"CO-013", name:"Leoni alati nero silicone", img:"https://via.placeholder.com/300?text=CO-013"},
    {code:"CO-014", name:"Bibbia oro TPU", img:"https://via.placeholder.com/300?text=CO-014"},
    {code:"CO-015", name:"Sorrento collo oro TPU", img:"https://via.placeholder.com/300?text=CO-015"},
    {code:"CO-016", name:"Sorrento collo nera silicone", img:"https://via.placeholder.com/300?text=CO-016"},
    {code:"CO-017", name:"Sorrento collo bianca silicone", img:"https://via.placeholder.com/300?text=CO-017"},
    {code:"CO-018", name:"1907 silicone", img:"https://via.placeholder.com/300?text=CO-018"},
    {code:"CO-019", name:"23/12/1945", img:"https://via.placeholder.com/300?text=CO-019"},

    /* --- TAGLIE --- */
    {code:"TG-XS",  name:"Taglia XS",  img:"https://via.placeholder.com/300?text=XS"},
    {code:"TG-S",   name:"Taglia S",   img:"https://via.placeholder.com/300?text=S"},
    {code:"TG-M",   name:"Taglia M",   img:"https://via.placeholder.com/300?text=M"},
    {code:"TG-L",   name:"Taglia L",   img:"https://via.placeholder.com/300?text=L"},
    {code:"TG-XL",  name:"Taglia XL",  img:"https://via.placeholder.com/300?text=XL"},
    {code:"TG-2XL", name:"Taglia 2XL", img:"https://via.placeholder.com/300?text=2XL"},
    {code:"TG-3XL", name:"Taglia 3XL", img:"https://via.placeholder.com/300?text=3XL"},
    {code:"TG-4XL", name:"Taglia 4XL", img:"https://via.placeholder.com/300?text=4XL"},

    /* --- SPECIALI (se ne aggiungi) --- */
    {code:"SP-001", name:"Patch Speciale GOLD", img:"https://via.placeholder.com/300?text=SP-001"}
  ];


  /* ==========================================================
     📘 RICETTE PRODOTTI (copiate dalle tue)
     ========================================================== */

  const productRecipes = {

    /* -------------------- VIS AURELIA -------------------- */

    "Vis Aurelia 25/26 Home": {
      "EZ-001": 1,
      "LG-001": 1,
      "AU-001": 1,
      "CO-001": 1
    },

    "Vis Aurelia Shorts 25/26 Home": {
      "EZ-001": 1,
      "LG-001": 1
    },

    "Vis Aurelia 25/26 Away": {
      "EZ-001": 1,
      "LG-001": 1,
      "AU-001": 1,
      "CO-001": 1
    },

    "Vis Aurelia Shorts 25/26 Away": {
      "EZ-001": 1,
      "LG-001": 1
    },


    /* ---------------------- BOREALE ----------------------- */

    "Boreale 23/24 Home": {
      "EZ-002": 1,
      "LG-002": 1,
      "AU-001": 1,
      "CO-002": 1
    },

    "Boreale 23/24 Third": {
      "EZ-008": 1,
      "LG-003": 1,
      "AU-001": 1,
      "CO-003": 1
    },

    "Boreale 24/25 Away": {
      "EZ-006": 1,
      "LG-002": 1,
      "AU-001": 1,
      "CO-004": 1
    },

    "Boreale Shorts 24/25 Away": {
      "EZ-006": 1,
      "LG-002": 1
    },

    "Boreale 25/26 Home": {
      "EZ-002": 1,
      "LG-002": 1,
      "AU-001": 1,
      "CO-002": 1
    },

    "Boreale Shorts 25/26 Home": {
      "EZ-002": 1,
      "LG-002": 1
    },

    "Boreale 25/26 Third": {
      "EZ-003": 1,
      "LG-004": 1,
      "AU-001": 1,
      "CO-005": 1
    },

    "Boreale Shorts 25/26 Third": {
      "EZ-003": 1,
      "LG-004": 1
    },


    /* ---------------------- OSTIAMARE ---------------------- */

    "Ostiamare 24/25 Home": {
      "EZ-002": 1,
      "LG-005": 1,
      "AU-001": 1,
      "CO-006": 1
    },

    "Ostiamare 24/25 Away": {
      "EZ-006": 1,
      "LG-005": 1,
      "AU-001": 1,
      "CO-007": 1
    },

    "Ostiamare 24/25 Third": {
      "EZ-002": 1,
      "LG-006": 1,
      "AU-001": 1,
      "CO-006": 1
    },

    "Ostiamare 24/25 Fourth": {
      "EZ-003": 1,
      "LG-007": 1,
      "AU-001": 1,
      "CO-008": 1
    },


    /* ----------------------- ROMULEA ----------------------- */

    "Romulea 24/25 Home": {
      "EZ-004": 1,
      "LG-008": 1,
      "AU-001": 1,
      "CO-009": 1
    },

    "Romulea Shorts 24/25 Home": {
      "EZ-004": 1,
      "LG-008": 1
    },

    "Romulea 24/25 Away": {
      "EZ-005": 1,
      "LG-008": 1,
      "AU-001": 1,
      "CO-010": 1
    },

    "Romulea Shorts 24/25 Away": {
      "EZ-005": 1,
      "LG-008": 1
    },

    "Romulea 24/25 Third": {
      "EZ-004": 1,
      "LG-008": 1,
      "AU-001": 1,
      "CO-009": 1
    },

    "Romulea Shorts 24/25 Third": {
      "EZ-004": 1,
      "LG-008": 1
    },


    /* ------------------------ LATINA ------------------------ */

    "Latina Sibò 24/25 Blackout": {
      "EZ-007": 1,
      "LG-009": 1,
      "AU-002": 1,
      "CO-011": 1
    },

    "Latina Sibò 24/25 Orange": {
      "EZ-007": 1,
      "LG-009": 1,
      "AU-002": 1,
      "CO-011": 1
    },

    "Latina Sibò 24/25 Color": {
      "EZ-007": 1,
      "LG-009": 1,
      "AU-002": 1,
      "CO-011": 1
    },

    "Latina 24/25 Home": {
      "EZ-002": 1,
      "LG-009": 1,
      "AU-001": 1,
      "CO-012": 1
    },

    "Latina 24/25 Away": {
      "EZ-003": 1,
      "LG-009": 1,
      "AU-001": 1,
      "CO-013": 1
    },

    "Latina 25/26 Home": {
      "EZ-001": 1,
      "LG-010": 1,
      "AU-001": 1,
      "CO-014": 1
    },

    "Latina Shorts 25/26 Home": {
      "EZ-001": 1,
      "LG-010": 1
    },

    "Latina 25/26 Away": {
      "EZ-003": 1,
      "LG-010": 1,
      "AU-001": 1,
      "CO-014": 1
    },

    "Latina Shorts 25/26 Away": {
      "EZ-003": 1,
      "LG-010": 1
    },

    "Latina 25/26 Third": {
      "EZ-001": 1,
      "LG-011": 1,
      "AU-001": 1,
      "CO-014": 1
    },

    "Latina Shorts 25/26 Third": {
      "EZ-001": 1,
      "LG-011": 1
    },

    "Latina 25/26 Home GK": {
      "EZ-001": 1,
      "LG-010": 1,
      "AU-001": 1,
      "CO-014": 1
    },

    "Latina Shorts 25/26 Home GK": {
      "EZ-001": 1,
      "LG-010": 1
    },

    "Latina 25/26 Away GK": {
      "EZ-003": 1,
      "LG-010": 1,
      "AU-001": 1,
      "CO-014": 1
    },

    "Latina Shorts 25/26 Away GK": {
      "EZ-003": 1,
      "LG-010": 1
    },

    "Latina 25/26 Third GK": {
      "EZ-003": 1,
      "LG-010": 1,
      "AU-001": 1,
      "CO-014": 1
    },

    "Latina Shorts 25/26 Third GK": {
      "EZ-003": 1,
      "LG-010": 1
    },


    /* ----------------------- SORRENTO ----------------------- */

    "Sorrento 25/26 Home": {
      "EZ-001": 1,
      "LG-012": 1,
      "AU-001": 1,
      "CO-015": 1
    },

    "Sorrento Shorts 25/26 Home": {
      "EZ-001": 1,
      "LG-012": 1
    },

    "Sorrento 25/26 Away": {
      "EZ-003": 1,
      "LG-013": 1,
      "AU-001": 1,
      "CO-016": 1
    },

    "Sorrento Shorts 25/26 Away": {
      "EZ-003": 1,
      "LG-013": 1
    },

    "Sorrento 25/26 Home GK": {
      "EZ-003": 1,
      "LG-012": 1,
      "AU-001": 1,
      "CO-016": 1
    },

    "Sorrento Shorts 25/26 Home GK": {
      "EZ-003": 1,
      "LG-012": 1
    },

    "Sorrento 25/26 Away GK Tiffany": {
      "EZ-002": 1,
      "LG-013": 1,
      "AU-001": 1,
      "CO-017": 1
    },

    "Sorrento Shorts 25/26 Away GK Tiffany": {
      "EZ-002": 1,
      "LG-013": 1
    },

    "Sorrento 25/26 Away GK Black": {
      "EZ-002": 1,
      "LG-013": 1,
      "AU-001": 1,
      "CO-017": 1
    },

    "Sorrento Shorts 25/26 Away GK Black": {
      "EZ-002": 1,
      "LG-013": 1
    },

    "Sorrento 25/26 80s": {
      "EZ-003": 1,
      "LG-014": 1,
      "AU-001": 1,
      "CO-019": 1
    },

    "Sorrento Shorts 25/26 80s": {
      "EZ-003": 1,
      "LG-014": 1
    },


    /* ----------------------- ALBAROMA ----------------------- */

    "Albaroma 24/25 Home": {
      "EZ-002": 1,
      "LG-015": 1,
      "AU-001": 1,
      "CO-018": 1
    },

    "Albaroma Shorts 25/26 Home": {
      "EZ-002": 1,
      "LG-015": 1
    }

  };


  /* ==========================================================
     🔐 PASSWORD DI ACCESSO
     ========================================================== */

  function checkPW() {
    const ACCESS_PW = "latina2025";
    const val = document.getElementById("pw-input")?.value || "";

    if (val !== ACCESS_PW) {
      alert("Password errata");
      return;
    }

    const gate = document.getElementById("password-gate");
    const app = document.getElementById("warehouse-app");
    if (gate) gate.style.display = "none";
    if (app) app.style.display = "block";

    init();
  }


  /* ==========================================================
     🎨 RENDER GRIGLIA PATCH
     ========================================================== */

  async function renderPatchGrid() {
    const stock = await loadStock();
    const grid = document.getElementById("patch-grid");
    if (!grid) return;

    grid.innerHTML = "";

    patchList.forEach(patch => {
      const div = document.createElement("div");
      div.className = "patch-card";

      div.innerHTML = `
        <img src="${patch.img}" class="patch-icon" alt="${patch.code}">
        <div class="patch-text-block">
          <div class="patch-title">${patch.name}</div>
          <div class="patch-code">${patch.code}</div>
        </div>
        <div class="patch-stock-number">${stock[patch.code] ?? 0}</div>
      `;

      grid.appendChild(div);
    });
  }


  /* ==========================================================
     🧩 POPOLAMENTO SELECT PATCH
     ========================================================== */

  function populateAddStockSelect() {
    const sel = document.getElementById("add-item");
    if (!sel) return;

    sel.innerHTML = "";

    patchList.forEach(p => {
      sel.innerHTML += `<option value="${p.code}">${p.code} — ${p.name}</option>`;
    });
  }


  /* ==========================================================
     🧩 POPOLAMENTO SELECT PRODOTTI
     ========================================================== */

  function populateProductSelect() {
    const sel = document.getElementById("product-select");
    if (!sel) return;

    sel.innerHTML = "";

    Object.keys(productRecipes).forEach(prod => {
      sel.innerHTML += `<option value="${prod}">${prod}</option>`;
    });
  }


  /* ==========================================================
     ➕ AGGIUNTA STOCK (Sheets)
     ========================================================== */

  async function addStockInternal() {
    const codeEl = document.getElementById("add-item");
    const qtyEl  = document.getElementById("add-qty");

    if (!codeEl || !qtyEl) {
      alert("Errore interno: campi mancanti.");
      return;
    }

    const code = codeEl.value;
    const qty  = parseInt(qtyEl.value);

    if (!qty || qty <= 0) {
      alert("Quantità non valida");
      return;
    }

    const deltas = {};
    deltas[code] = qty; // Aggiunta → delta positivo

    await applyDeltas(deltas);
    await renderPatchGrid();

    alert("Stock aggiornato con successo.");
  }


  /* ==========================================================
     🏭 PROCESSA ORDINE DI PRODUZIONE (Sheets)
     ========================================================== */

  async function processOrderInternal() {
    const prodSel = document.getElementById("product-select");
    if (!prodSel) {
      alert("Errore interno: select prodotto mancante.");
      return;
    }

    const prod = prodSel.value;
    const recipe = productRecipes[prod];

    if (!recipe) {
      alert("Ricetta non trovata.");
      return;
    }

    /* ---- Quantità per taglia ---- */
    const qtyXS  = parseInt(document.getElementById("qty-xs")?.value)  || 0;
    const qtyS   = parseInt(document.getElementById("qty-s")?.value)   || 0;
    const qtyM   = parseInt(document.getElementById("qty-m")?.value)   || 0;
    const qtyL   = parseInt(document.getElementById("qty-l")?.value)   || 0;
    const qtyXL  = parseInt(document.getElementById("qty-xl")?.value)  || 0;
    const qty2XL = parseInt(document.getElementById("qty-2xl")?.value) || 0;
    const qty3XL = parseInt(document.getElementById("qty-3xl")?.value) || 0;
    const qty4XL = parseInt(document.getElementById("qty-4xl")?.value) || 0;

    const totalQty =
      qtyXS + qtyS + qtyM + qtyL + qtyXL + qty2XL + qty3XL + qty4XL;

    if (totalQty <= 0) {
      alert("Inserisci almeno una quantità.");
      return;
    }

    /* ---- Carica stock attuale da Sheets ---- */
    const stock = await loadStock();

    /* ---- Controllo disponibilità taglie ---- */
    const taglie = {
      "TG-XS": qtyXS,
      "TG-S": qtyS,
      "TG-M": qtyM,
      "TG-L": qtyL,
      "TG-XL": qtyXL,
      "TG-2XL": qty2XL,
      "TG-3XL": qty3XL,
      "TG-4XL": qty4XL
    };

    for (const t in taglie) {
      const q = taglie[t];
      if (q > 0 && (stock[t] ?? 0) < q) {
        alert(`Stock taglia insufficiente: ${t} (disp. ${stock[t] ?? 0}, servono ${q})`);
        return;
      }
    }

    /* ---- Controllo disponibilità patch fisse ---- */
    for (const patchCode in recipe) {
      const required = recipe[patchCode] * totalQty;
      if ((stock[patchCode] ?? 0) < required) {
        alert(`Stock insufficiente per ${patchCode} (disp. ${stock[patchCode] ?? 0}, servono ${required})`);
        return;
      }
    }

    /* ======================================================
       📉 CREA DELTAS (negativi perché stai scalando stock)
       ====================================================== */
    const deltas = {};

    // taglie
    for (const t in taglie) {
      if (taglie[t] > 0) deltas[t] = -taglie[t];
    }

    // patch per ricetta
    for (const p in recipe) {
      deltas[p] = -(recipe[p] * totalQty);
    }

    /* ---- Applica deltas al foglio ---- */
    await applyDeltas(deltas);

    /* ---- Aggiorna UI ---- */
    await renderPatchGrid();

    alert(`Ordine completato: ${totalQty} pezzi scalati dal magazzino.`);
  }


  /* ==========================================================
     🎯 BIND BOTTONI (senza usare onclick globali)
     ========================================================== */

  function bindButtons() {
    // Prende tutti i bottoni dentro le due .warehouse-box
    const boxes = document.querySelectorAll("#warehouse-app .warehouse-box .warehouse-btn");
    if (!boxes || boxes.length < 2) {
      console.warn("Bottoni warehouse non trovati o incompleti:", boxes);
      return;
    }

    const addBtn  = boxes[0]; // primo: Aggiungi
    const procBtn = boxes[1]; // secondo: Scala Magazzino

    addBtn.addEventListener("click", (e) => {
      e.preventDefault();
      addStockInternal();
    });

    procBtn.addEventListener("click", (e) => {
      e.preventDefault();
      processOrderInternal();
    });
  }


  /* ==========================================================
     🚀 INIT (carica tutto + render)
     ========================================================== */

  async function init() {
    populateAddStockSelect();
    populateProductSelect();
    await renderPatchGrid();
    bindButtons();
  }


  /* ==========================================================
     ESPORTA SOLO checkPW PER IL BOTTONE "ENTRA"
     ========================================================== */

  window.checkPW = checkPW;

})();